export const UploadImages = {
  Validation: {
    InvalidExtension: 'jpegまたはpng形式の画像をアップロードしてください。',
  },
};
